import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Lock, Play } from 'lucide-react';
interface EpisodeListProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectEpisode: (id: number) => void;
}
const episodes = [{
  id: 1,
  title: 'EPISODIO 1 — DESAPARECIDA',
  desc: 'Carmen desaparece sin dejar rastro.',
  locked: false
}, {
  id: 2,
  title: 'EPISODIO 2 — AUTOPSIA',
  desc: 'Los resultados revelan algo inesperado.',
  locked: true
}, {
  id: 3,
  title: 'EPISODIO 3 — LAS PRUEBAS',
  desc: 'Las pruebas no cuadran.',
  locked: true
}, {
  id: 4,
  title: 'EPISODIO 4 — LA NOCHE DEL 15',
  desc: '¿Qué pasó realmente esa noche?',
  locked: true
}, {
  id: 5,
  title: 'EPISODIO 5 — EL AUTO BLANCO',
  desc: 'Un vehículo blanco aparece en la investigación.',
  locked: true
}, {
  id: 6,
  title: 'EPISODIO 6 — LA VERDAD',
  desc: 'Todo se resuelve.',
  locked: true
}];
export function EpisodeList({
  isOpen,
  onClose,
  onSelectEpisode
}: EpisodeListProps) {
  return <AnimatePresence data-id="element-64">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40" data-id="element-65" />

          {/* Sidebar */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed right-0 top-0 bottom-0 w-full md:w-[500px] bg-[var(--bg-card)] border-l border-white/10 z-50 overflow-y-auto shadow-2xl" data-id="element-66">
            <div className="p-8" data-id="element-67">
              <div className="flex justify-between items-center mb-12" data-id="element-68">
                <h2 className="text-2xl font-serif tracking-widest text-[var(--text-primary)]" data-id="element-69">
                  EXPEDIENTE
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-full transition-colors text-[var(--text-secondary)] hover:text-white" aria-label="Cerrar lista" data-id="element-70">
                  <X className="w-6 h-6" data-id="element-71" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-72">
                {episodes.map((ep, index) => <motion.div key={ep.id} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.1
            }} onClick={() => !ep.locked && onSelectEpisode(ep.id)} className={`group relative p-6 border border-white/5 rounded-sm transition-all duration-300 ${ep.locked ? 'opacity-50 cursor-not-allowed' : 'hover:bg-white/5 hover:border-[var(--accent)] cursor-pointer'}`} data-id="element-73">
                    <div className="flex justify-between items-start mb-2" data-id="element-74">
                      <span className="text-xs font-bold tracking-widest text-[var(--accent)]" data-id="element-75">
                        0{ep.id}
                      </span>
                      {ep.locked ? <Lock className="w-4 h-4 text-[var(--text-secondary)]" data-id="element-76" /> : <Play className="w-4 h-4 text-[var(--text-primary)] group-hover:text-[var(--accent)] transition-colors" data-id="element-77" />}
                    </div>

                    <h3 className={`text-lg font-serif mb-2 ${ep.locked ? 'text-[var(--text-secondary)]' : 'text-[var(--text-primary)]'}`} data-id="element-78">
                      {ep.title}
                    </h3>

                    <p className="text-sm text-[var(--text-secondary)] font-light" data-id="element-79">
                      {ep.desc}
                    </p>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}